import { getUserInfo } from "@/api/public"
let userInformation = async function(val) {
  var obj = await getUserInfo()
  return obj
}
export { userInformation }



// WEBPACK FOOTER //
// ./src/utils/userInfo.js